import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '../../../components/atoms/PrimaryButton'
import SecondaryButton from '../../../components/atoms/SecondaryButton'
import FullScreenPopup from '../../../components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '../../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import SettingContext from '../../../context/setting/settingContext'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import Layout from '../../../components/templates/Layout'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const TemplateManage = (props) => {
    const search = useLocation().search
    const edit = new URLSearchParams(search).get('edit')
    const { allMaintanenceData } = useContext(CustomCommonContext)

    const { t } = useTranslation()
    const settingContext = useContext(SettingContext)

    const { maintanenceAction } = settingContext

    const [reload, setReload] = useState(false)

    const validationArray = Yup.object({
        exclude_ip: Yup.string(),
        exclude_route: Yup.string(),
        message: Yup.string(),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            exclude_ip: '',
            exclude_route: '',
            message: '',
            active: false,
        },
        validationSchema: validationArray,
        // validateOnBlur: false,
        // enableReinitialize: true,
        onSubmit: (values) => {
            maintanenceAction(values)
        },
    })

    // useEffect(() => {
    //     resetFrom()
    // }, [props])

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.setFieldValue('value', '')
        formik.setFieldValue('value_array', [])
        formik.setFieldValue('type', '')
        formik.setFieldValue('question', '')
        formik.setFieldValue('variable', '')
        formik.setFieldValue('enabled', 1)
        formik.handleReset()
        formik.resetForm()
        setReload(!reload)
    }

    useEffect(() => {
        if (allMaintanenceData) {
            const template = allMaintanenceData
            console.log('template', template)
            formik.setFieldValue('id', template.id)
            formik.setFieldValue('exclude_ip', template.exclude_ip || '')
            formik.setFieldValue('exclude_route', template.exclude_route || '')
            formik.setFieldValue('message', template.message || '')
            formik.setFieldValue(
                'active',
                template.active === 1 ? true : false || false
            )
        }
        setReload(!reload)
    }, [allMaintanenceData])

    const emailTemplate = {
        formik: formik,
        data: [
            {
                label: t('Exclude IP'),
                placeholder: t('Enter Exclude IP'),
                class: 'col-12 mb-4',
                type: 'text',
                name: 'exclude_ip',
            },
            {
                label: t('Exclude route'),
                placeholder: t('Enter Exclude route'),
                class: 'col-12 mb-4',
                type: 'text',
                name: 'exclude_route',
            },
            {
                label: t('Message'),
                placeholder: t('Enter Message'),
                class: 'col-12 mb-4',
                type: 'text',
                name: 'message',
            },
            {
                label: t('Active'),
                placeholder: t('Make Active'),
                type: 'switch',
                class: 'col-12 mb-4',
                name: 'active',
            },
        ],
    }

    return (
        <>
            <Layout
                noUI={props.noUI || false}
                renderSidePanelDefault={props.renderSidePanelDefault || false}
            >
                {' '}
                <div className="dashboard staticPages">
                    <div className="fspBody">
                        <form autoComplete="nofill">
                            <div className="row">{mapData(emailTemplate)}</div>

                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <PrimaryButton
                                    id="config_submit"
                                    label={t('Submit')}
                                    onClick={formik.handleSubmit}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default TemplateManage
